import { Box, Stack, Typography } from "@mui/material";
import { DebugBox, LoadingBox, useNavigateWithParams } from "@northpowerdev/np-react-utils";
import { plural } from "../../../utils/utilityFunctions";
import useFetchJson from "../../../data/useFetchJson";
import { hikoAlert } from "../../../utils/HikoAlert";
import { useGetParams } from "../../../utils/useGetParams";
import { useEffect } from "react";
import { DlspBreadcrumbs } from "./DlspBreadcrumbs";
import { StyledDataGrid } from "./DlspStyledDataGrid";
import { AssigneeSelect } from "./AssigneeSelect";
import { useState } from "react";

const gridColumns = [
    { field: 'suburb',       headerName: 'Suburb',           flex: 1 },
    { field: 'Total',        headerName: 'Total',            flex: 1, headerClassName: 'status-new',           valueGetter: (params) => getTotal(params) },
    { field: 'Desktop',      headerName: 'Desktop',          flex: 1, headerClassName: 'status-desktop',       valueGetter: (params) => getByStatus(params, 'Desktop') },
    { field: 'Desktop QA',   headerName: 'Desktop QA',       flex: 1, headerClassName: 'status-desktop-qa',    valueGetter: (params) => getByStatus(params, 'Desktop QA') },
    { field: 'Field',        headerName: 'Field',            flex: 1, headerClassName: 'status-field',         valueGetter: (params) => getByStatus(params, 'Field') },
    { field: 'Field QA',     headerName: 'Field QA',         flex: 1, headerClassName: 'status-field-qa',      valueGetter: (params) => getByStatus(params, 'Field QA') },
    { field: 'Remedial',     headerName: 'Remedial',         flex: 1, headerClassName: 'status-remedial',      valueGetter: (params) => getByStatus(params, 'Remedial') },
    { field: 'FSP',          headerName: 'FSP',              flex: 1, headerClassName: 'status-fsp',           valueGetter: (params) => getByStatus(params, 'FSP') },
    { field: 'Eliminated',   headerName: 'Eliminated',       flex: 1, headerClassName: 'status-eliminated',    valueGetter: (params) => getByStatus(params, 'Eliminated') },
];

function getByStatus(params, status) {
    return params.row.byStatus[status]
}

function getTotal(params) {
    // console.log('getTotal params', params)
    return Object.values(params.row.byStatus).reduce((val, accumulator) => accumulator + val, 0)
}

export default function DlspStormAreaSuburbList() {

    const [taskListWithTotals, setTaskListWithTotals] = useState([])

    const navigateToUpdateAssignee = useNavigateWithParams('/dlsp/storm_area_suburb_list')
    const navigateToSuburbTaskList = useNavigateWithParams('/dlsp/suburb_task_list')

    const summaryBasePath = '/bff/decommissioned-lines-service/api/decommissioned-lines/summary-by-suburb'
    const {
        isLoading: taskSummaryLoading,
        data: taskSummaryList,
        load: getStormAreaDetails,
        } = useFetchJson(summaryBasePath) 


    const getParams = useGetParams(['storm_area', 'assignee'])

    useEffect(() => {

        if (!getParams || !getParams.storm_area) {
            return
        }
        let params = {params: {stormArea: getParams.storm_area}}
        if (getParams.assignee) {
            params.params.assignee = getParams.assignee
        }
        getStormAreaDetails(params)

    }, [getParams, getStormAreaDetails])

   useEffect(() => {
        if (!taskSummaryList) {
            return
        }

        const totalByStatus = (summaryList, statusName) => {
            const theTotal = summaryList.reduce((accumulator, element) => {
                return accumulator + (element.byStatus[statusName] || 0)
            }, 0)
            return theTotal
        }

        setTaskListWithTotals(
        [
            ...taskSummaryList,
            {
                "suburb": "Totals",
                "byStatus": {
                    "Desktop":     totalByStatus(taskSummaryList, "Desktop"),
                    "Desktop QA":  totalByStatus(taskSummaryList, "Desktop QA"),
                    "Field":       totalByStatus(taskSummaryList, "Field"),
                    "Field QA":    totalByStatus(taskSummaryList, "Field QA"),
                    "Remedial":    totalByStatus(taskSummaryList, "Remedial"),
                    "FSP":         totalByStatus(taskSummaryList, "FSP"),
                    "Eliminated":  totalByStatus(taskSummaryList, "Eliminated")
                }
            }
        ])
    }, [taskSummaryList])

    const handleCellClick = (params, event, details) => {
        console.log('handleCellClick', {params, event, details})
        console.log('handleCellClick params.field', params.field)
        if (!params.row.suburb || params.row.suburb === 'Totals') {
            hikoAlert('No suburb in that row!')
            return
        }
        let navigateParams = {
            storm_area: getParams.storm_area,
            suburb: params.row.suburb,
        }
        if (['Desktop','Desktop QA','Field','Field QA','Remedial','FSP','Eliminated'].includes(params.field)) {
            navigateParams.status = params.field
        }
        if (getParams.assignee) {
            navigateParams.assignee = getParams.assignee
        }
        navigateToSuburbTaskList(navigateParams)
    }

    const handleAssigneeSelected = (newAssignee) => {
        console.log('DlspStormAreaSuburbList handleAssigneeSelected newAssignee', newAssignee)
        // setSelectedAssingee(newAssignee)
        navigateToUpdateAssignee({...getParams, assignee: newAssignee} )
    }

    return (
        <Box className="Page">
            <h3>Decommissioned Lines Safety Project</h3>
            <h2>Summary of storm area {getParams?.storm_area} {getParams?.assignee && `for ${getParams?.assignee}`}</h2>

            <DlspBreadcrumbs
                assignee={getParams?.assignee}
                stormArea={getParams?.storm_area}
            />

            <LoadingBox loading={taskSummaryLoading}>
                <Stack direction="row" sx={{justifyContent: 'space-between', alignItems: 'center'}}>
                    <Typography variant="body1">We found {(taskListWithTotals?.length - 1) || 'no'} suburb{plural((taskListWithTotals?.length - 1))}.</Typography>
                    <AssigneeSelect assignee={getParams?.assignee || ''} onChange={handleAssigneeSelected} />
                </Stack>
                <StyledDataGrid sx={{my:2}} autoHeight rows={taskListWithTotals || []}
                    getRowId={(row) => row.suburb}
                    columns={gridColumns}
                    onCellClick={handleCellClick}
                    getRowClassName={(params) => params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'}
                />
            </LoadingBox>
            <DebugBox title="taskListWithTotals" stringify>{taskListWithTotals}</DebugBox>
        </Box>
    )
}

